// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610061035/js/" + chunkId + "." + {"44":"47d58b8f","225":"372aa986","481":"60d07676","486":"3c79319e","770":"79cf1afa"}[chunkId] + ".0.5626519492263266.chunk.js";
};